import { Link } from 'react-router-dom';
import Button from '../primitives/Button';

/**
 * User-facing fallback when a route or the app shell fails to render.
 */
export default function ErrorFallback({
  title = 'Something went wrong',
  message = 'This page could not be displayed. You can reload or return to the dashboard.',
  error = null,
  onReload,
  onRetry,
  showDashboardLink = true,
  compact = false,
}) {
  const detail =
    process.env.NODE_ENV !== 'production' && error?.message
      ? error.message
      : null;

  const content = (
    <div className={`mx-auto text-center ${compact ? 'max-w-md px-4 py-10' : 'max-w-lg px-6 py-16'}`}>
      <div
        className="inline-flex items-center justify-center w-12 h-12 rounded-full mb-4 text-lg font-semibold"
        style={{
          background: 'var(--risk-high-bg)',
          color: 'var(--risk-high-fg)',
          border: '1px solid var(--risk-high-border)',
        }}
        aria-hidden
      >
        !
      </div>
      <h1
        className={`font-semibold tracking-tight mb-2 ${compact ? 'text-lg' : 'text-xl'}`}
        style={{ color: 'var(--text-primary)' }}
      >
        {title}
      </h1>
      <p className="text-sm leading-relaxed mb-6" style={{ color: 'var(--text-muted)' }}>
        {message}
      </p>

      {detail && (
        <pre
          className="text-left text-[11px] leading-snug mb-6 p-3 rounded-lg overflow-x-auto"
          style={{
            background: 'var(--bg-s2)',
            color: 'var(--text-secondary)',
            border: '1px solid var(--border-divider)',
          }}
        >
          {detail}
        </pre>
      )}

      <div className="flex flex-wrap items-center justify-center gap-2">
        {onReload && (
          <Button variant="primary" onClick={onReload}>
            Reload page
          </Button>
        )}
        {onRetry && (
          <Button variant="secondary" onClick={onRetry}>
            Try again
          </Button>
        )}
        {showDashboardLink && (
          <Link to="/app/dashboard" className="app-btn-pill app-btn-pill--secondary no-underline">
            Return to dashboard
          </Link>
        )}
      </div>
    </div>
  );

  if (compact) return content;

  return (
    <div
      className="min-h-screen flex items-center justify-center"
      style={{ background: 'var(--bg-dashboard)', color: 'var(--text-primary)' }}
    >
      {content}
    </div>
  );
}
